import { render, staticRenderFns } from "./editrule.vue?vue&type=template&id=97b81872&scoped=true"
import script from "./editrule.vue?vue&type=script&lang=js"
export * from "./editrule.vue?vue&type=script&lang=js"
import style0 from "./editrule.vue?vue&type=style&index=0&id=97b81872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b81872",
  null
  
)

export default component.exports